const STALE_ASSET_RELOAD_KEY = 'krafta.ui.staleAssetReloadAt';

export const STALE_ASSET_RELOAD_COOLDOWN_MS = 60_000;

type StaleAssetRecoveryTarget = {
  addEventListener(type: string, listener: EventListener): void;
  sessionStorage: Pick<Storage, 'getItem' | 'setItem'>;
  location: Pick<Location, 'reload'>;
};

const readLastReloadAt = (storage: StaleAssetRecoveryTarget['sessionStorage']) => {
  try {
    const value = Number(storage.getItem(STALE_ASSET_RELOAD_KEY));
    return Number.isFinite(value) ? value : 0;
  } catch {
    return 0;
  }
};

const recordReloadAt = (
  storage: StaleAssetRecoveryTarget['sessionStorage'],
  timestamp: number
) => {
  try {
    storage.setItem(STALE_ASSET_RELOAD_KEY, String(timestamp));
  } catch {
    // Reload still recovers the current page when storage is unavailable.
  }
};

export const installStaleAssetRecovery = (
  target: StaleAssetRecoveryTarget,
  now: () => number = Date.now
) => {
  target.addEventListener('vite:preloadError', (event) => {
    const timestamp = now();
    if (
      timestamp - readLastReloadAt(target.sessionStorage) <
      STALE_ASSET_RELOAD_COOLDOWN_MS
    ) {
      return;
    }

    event.preventDefault();
    recordReloadAt(target.sessionStorage, timestamp);
    target.location.reload();
  });
};
